import * as React from 'react';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { Button } from '../General/Button';
import { IconImg } from '../../Defaults/Icon/IconImg';
import { FlexRow, FlexColCenter } from '../../Defaults/Flexbox/Flexbox';
import { SvgIcon } from '../General/SvgIcon';

interface Props {
  onButtonClick: any;
  onRequestClick: any;
  disabled?: boolean;
}

function ButtonWithRequest({ onButtonClick, onRequestClick, disabled }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const correctRotation = isOpen ? 180 : 0;

  const toggleOpen = e => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleRequestClick = e => {
    onRequestClick();
  };

  return (
    <Wrapper>
      <CartButton disabled={disabled} type="button" onClick={onButtonClick}>
        <IconImg
          disabled={disabled}
          cursor={'pointer'}
          src={'/assets/zemplin/cart.svg'}
          alt="Pridať do košíka"
        />
      </CartButton>
      <DropdownArrow onClick={toggleOpen}>
        <IconImg
          cursor={'pointer'}
          rotate={correctRotation}
          src={'/assets/zemplin/arrow-triangle.svg'}
          alt="Šípka"
          width={8}
          height={4}
        />
      </DropdownArrow>
      {isOpen && (
        <DropdownWrapper type="button" onClick={handleRequestClick}>
          {'Dopytovať'}
        </DropdownWrapper>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  position: relative;
  justify-content: flex-end;
  margin-left: ${rem(8)};
  min-width: ${rem(64)};
`;

const CartButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.secondary};
  border-radius: ${rem(2)} 0px 0px ${rem(2)};
  padding: ${rem(12)};
  margin-right: ${rem(1)};

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.secondary)};
    transition: background-color 0.2s ease;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
  }
`;

const DropdownArrow = styled(FlexColCenter)`
  padding: ${rem(22)} ${rem(8)};
  background-color: ${({ theme }) => theme.colors.secondary};
  border-radius: 0 ${rem(2)} ${rem(2)} 0;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.secondary)};
    transition: background-color 0.2s ease;
  }
`;

const DropdownWrapper = styled(Button)`
  position: absolute;
  top: ${rem(49)};
  right: 0;
  background-color: ${({ theme }) => theme.colors.secondary};
  width: ${rem(160)};
  height: ${rem(48)};
  box-shadow: ${({ theme }) => theme.boxShadow.default};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  border-radius: ${rem(2)};
  z-index: 1;

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.secondary)};
    transition: background-color 0.2s ease;
  }
`;

export { ButtonWithRequest };
